
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';

const { currency } = api;

@Component({
  components: { },
})
export default class VirtualCurrencyList extends Vue {
  private data = { data: [] };

  private headers = [
    { text: '名稱', value: 'name', width: '30%' },
    { text: 'LOGO', value: 'pic', width: '10%' },
    { text: '簡稱', value: 'shortCode', width: '30%' },
    { text: '修改', value: 'edit', width: '10%' },
    { text: '啟用', value: 'enable', width: '10%' },
    { text: '刪除', value: 'delete', width: '10%' },
  ];

  private get collection() {
    return [...(this.data.data || [])];
  }

  private async handleEditEnable(currencyId: string, isEnabled: boolean) {
    const message = isEnabled ? '停用' : '啟用';
    await Swal.fire(
      {
        title: `您確定要${message}嗎?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status } = await currency.modifyStatus(currencyId, !isEnabled);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: `${message}成功` });
          await this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: `${message}失敗，請聯繫系統管理員。` });
        }
      }
    });
  }

  private async handleOpenDelete(currencyId: any) {
    await Swal.fire(
      {
        title: '您確定要刪除嗎?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確定',
        cancelButtonText: '取消',
      },
    ).then(async (result) => {
      if (result.isConfirmed) {
        const { status, message } = await currency.delete(currencyId);
        if (status === 1) {
          await Swal.fire({ icon: 'success', title: '刪除成功' });
          this.requestData();
        } else {
          await Swal.fire({ icon: 'warning', title: message });
        }
      }
    });
  }

  private async requestData() {
    const { data } = await currency.list({ pageSize: 0, pageNo: 1 });
    this.data = data;
  }

  private async created() {
    await this.requestData();
  }
}
